<div
  #paymentBlock
  *appHasAccess="['PAYMENT_VIEW']"
  class="payment-page">
  <div class="page-head">
    <div class="page-head__left"></div>
    <div class="page-head__right">
      <app-filter-button
        [isOpenFilter]="isOpenFilter"
        [isEnableUpload]="permissionService.hasPermission(['PAYMENT_LIST'])"
        (toggleFilterEvent)="toggleFilter($event)"
        (uploadEvent)="upload()">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-payment-page-filter
        [filterCurrencies]="filterCurrencies"
        [filterBanks]="filterBanks"
        [filterDirections]="filterDirections"
        [filterPaymentTypes]="filterPaymentTypes"
        [filterStatuses]="filterStatuses">
      </app-payment-page-filter>
    </app-filter-block>
  </div>

  <div class="user-page__body">
    <div
      #tableBlock
      (scroll)="onScroll($event)"
      class="table">
      <div class="table-head">
        <div class="table__row">
          <div class="column table__row-head"></div>
          <div
            (click)="sortColumn('ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.ID_PAYMENT" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('REC_PAYMENT_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'REC_PAYMENT_ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ 'PAYMENT_PAGE.MODAL_INFO.RECURRENT_ID' | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('BILL_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BILL_ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.ID_IN_SYSTEM" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('FULL_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'FULL_NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.FUL_NAME" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('PAYMENT_SUM')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PAYMENT_SUM'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.PAYMENT_SUM" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('CURRENCY')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'CURRENCY'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.CURRENCY" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('BANK_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BANK_NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.BANK_NAME" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('PAYMENT_STATUS')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PAYMENT_STATUS'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.PAYMENT_STATUS" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('PAYMENT_DATE')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PAYMENT_DATE'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.PAYMENT_DATE" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('PAYMENT_TYPE')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'PAYMENT_TYPE'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.PAYMENT_TYPE" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('VIRTUAL_POS_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'VIRTUAL_POS_ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "PAYMENT_PAGE.VIRTUAL_ID" | translate }}
            </span>
          </div>
        </div>
      </div>
      <div
        #tableBody
        class="table-body">
        <div
          *ngFor="let item of paymentList"
          (dblclick)="openModalDetail(item.id)"
          (click)="openModalDetailMobile(item.id)"
          class="table__row">
          <div class="column table__row-data">
            <ng-container *appHasAccess="['PAYMENT_REFUND']">
              <button
                *ngIf="
                  !(
                    item.payment_type === 'RETURNS' ||
                    item.payment_type === 'P2P_OPERATION' ||
                    item.payment_type === 'P2P_REFUNDS' ||
                    item.payment_type === 'CASH_REFUNDS' ||
                    item.payment_status === 'UNREGISTERED' ||
                    item.payment_status === 'REGISTRATION_STARTED'
                  ) && item.refund_available_sum
                "
                (click)="openModalDeletePayment(item.id)"
                (dblclick)="stopProp($event)"
                class="return-btn">
                <img
                  src="assets/img/return.svg"
                  alt="Return"
                  class="return-btn__icon" />
                <span class="return-btn__tooltip">{{ "PAYMENT_PAGE.RETURN_PAYMENT" | translate }}</span>
              </button>
            </ng-container>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "PAYMENT_PAGE.ID_PAYMENT" | translate }}: </span>
            {{ item.id }}
          </div>
          <div class="column table__row-data">
            <span class="mobile">
              {{ 'PAYMENT_PAGE.RECURRING_PAYMENT_ID' | translate }}:
            </span>
            {{ item.rec_payment_id ?? '-' }}
          </div>
          <div class="column table__row-data">
            <span
              *ngIf="item.bill_id"
              class="mobile"
              >{{ "PAYMENT_PAGE.ID_IN_SYSTEM" | translate }}: </span
            >{{ item.bill_id }}
          </div>
          <div class="column table__row-data">
            <span>{{ item.full_name }}</span>
            <span class="mobile">
              {{ item.sum }}
              {{ item.currency }}
            </span>
          </div>
          <div class="column table__row-data">
            {{ item.sum }}
          </div>
          <div class="column table__row-data">{{ item.currency }}</div>
          <div class="column table__row-data">
            <span class="mobile">{{ "PAYMENT_PAGE.BANK_NAME" | translate }}: </span>
            <span>{{ item.bank_name }}</span>
          </div>
          <div class="column table__row-data">
            <div
              class="payment-status"
              [class.green]="item.payment_status === 'PAID'"
              [class.blue]="item.payment_status === 'REGISTERED'"
              [class.gray]="item.payment_status === 'SUCCESSFUL_REFUND'"
              [class.light-blue]="item.payment_status === 'REGISTRATION_STARTED'"
              [class.orange]="item.payment_status === 'REFUND_INITIATED'"
              [class.red]="item.payment_status === 'UNREGISTERED'">
              <span>{{ "PAYMENT_PAGE.PAYMENT_STATUS_DESCRIPTION." + item.payment_status | translate }}</span>
            </div>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "PAYMENT_PAGE.FROM" | translate }} </span>
            <span>{{ item.date }}</span>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "PAYMENT_PAGE.PAYMENT_TYPE" | translate }}: </span>
            <span *ngIf="item.payment_type">{{ "PAYMENT_PAGE.PAYMENT_TYPE_DESCRIPTION." + item.payment_type | translate }}</span>
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "PAYMENT_PAGE.VIRTUAL_ID" | translate }}: </span>
            {{ item.virtual_pos_id }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal
  [isFull]="true"
  [(isOpenModal)]="isOpenPaymentDetail">
  <app-payment-detail-dialog
    (statusUpdateEvent)="statusUpdatedNotification()"
    (copyDetail)="copyDetail()">
  </app-payment-detail-dialog>
</app-modal>

<app-modal
  [isFull]="true"
  [(isOpenModal)]="isOpenDeletePaymentDialog">
  <app-return-payment-dialog
    (fileNotLoadedEvent)="fileNotDownloadNotification()"
    (p2pRefundEvent)="p2pNotification()"
    (refundSuccessEvent)="refundSuccessNotification()">
  </app-return-payment-dialog>
</app-modal>

<app-modal
  [isFull]="true"
  [(isOpenModal)]="isOpenSuccessDeletePaymentDialog">
  <app-delete-payment-success-dialog></app-delete-payment-success-dialog>
</app-modal>
